// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChartTable_wrapper__cGvbj"};